import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton, Stack } from '@mui/material';

interface SortableInclusionRowProps {
  id: string;
  children: React.ReactNode;
}

export default function SortableInclusionRow({ id, children }: SortableInclusionRowProps) {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({ id });

  return (
    <Stack
      ref={setNodeRef}
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        opacity: isDragging ? 0.75 : 1,
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...attributes}
    >
      <IconButton
        {...listeners}
        size="small"
        sx={{
          cursor: isDragging ? 'grabbing' : 'grab',
        }}
        aria-label="Reorder inclusion"
      >
        <DragIndicatorIcon />
      </IconButton>
      {children}
    </Stack>
  );
}
